module.exports = __webpack_public_path__ + "img/FR11550.da7023d2.png";